import * as zod from 'zod'

const name = zod
    .string()
    .trim()
    .max(128)
    .regex(/^[-_.? 0-9A-Za-zÀ-ÖØ-öø-ÿ]+$/u, {message: 'valid characters: alphanumeric, space, and -_.?'})

const email = zod.string().trim().max(128).email()

const captcha = zod.string()

const password = zod.string().trim()

export const SignInSchema = zod.object({name, password})
export type SignInSchema = zod.infer<typeof SignInSchema>

export const RecoverSignInSchema = zod.object({email})
export type RecoverSignInSchema = zod.infer<typeof RecoverSignInSchema>

export const ResetPasswordSchema = zod.object({password: password})
export type ResetPasswordSchema = zod.infer<typeof ResetPasswordSchema>

export const AddTeamMemberSchema = zod.object({name, email, password: password.optional()})
export type AddTeamMemberSchema = zod.infer<typeof AddTeamMemberSchema>

export const SignUpSchema = zod.object({name, password, email, captcha})
export type SignUpSchema = zod.infer<typeof SignUpSchema>

export const UpdateUserSchema = zod.object({name, email, password: password.optional()})
export type UpdateUserSchema = zod.infer<typeof UpdateUserSchema>
